import { useEffect } from "react";
import { sitemap } from "../utils/sitemap";

export const useSitemap = (): any => {
    useEffect(() => {
        sitemap()
    }, []);
};